<div class="modal-header" style="padding: 20px 30px; display: block; padding-bottom: 0px">
    <div class="row">
        <div class="col-xs-10 col-sm-10 col-md-10">
            <h3 *ngIf="!data.editPatient" class="modal-title">
                <img src="/assets/images/Group 240347.svg" style="width: 5%; padding-left: 5px; text-align: center"
                    alt="" />&nbsp;&nbsp;
                <span class="h3 font-thin" style="color: #58666e; font-size: 22px">Create {{'Patient' | customPatientLabel}}</span>
            </h3>
            <h3 *ngIf="data.editPatient" class="row">
                <img src="/assets/images/Upfront Icon/Group 240196.svg"
                    style="width: 4%; padding-left: 5px; text-align: center" alt="" />&nbsp;&nbsp;
                <div>
                    <span class="h3 font-thin" style="color: #58666e; font-size: 22px">Edit {{'Patient' | customPatientLabel}} Details</span>
                </div>

            </h3>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2">
            <button style="
                    border: none;
                    outline: none;
                    float: right;
                    background: transparent;
                " (click)="closeModal()">
                <img src="../../assets/images/close.svg" style="
                        color: white !important;
                        border-radius: 4px;
                        width: 28px;
                        margin-top: 5px;
                    " />
            </button>
        </div>
    </div>
</div>
<div class="modal-body" (scroll)="closeOpenDropdowns()"
    style="max-height: calc(90vh - 152px); overflow: auto; padding: 15px 30px; display: block">
    <span *ngIf="data.editPatient && editGeneralDetailsVisibleFields.size > 0">General Details</span>
    <div class="row" style="margin-bottom: 8px; ">
        <div *ngIf="hasField('patientId', 'edit', 'create')" class="col-md-3" style="margin-bottom: 8px;">
            <p>{{'Patient ID' | customPatientLabel}} <span style="color: red;" *ngIf="isRequired('patientId')">*</span></p>
            <!-- <div class="search-container">
                <input [disabled]="
                        data.editPatient && data.patientDetails?.externalId
                    " tabindex="1" type="text" placeholder="{{'Patient ID' | customPatientLabel}}" (keydown.space)="$event.preventDefault()"
                    [(ngModel)]="
                        patientInformationObject.patientInfo.externalId
                    " (keyup.enter)="searchByMRN($event)" (paste)="removeAllSpace()" placeholder="Search" />
                <button *ngIf="data.editPatient && !data.patientDetails?.externalId" (click)="searchByMRN()"
                    class="search-btn">
                    <i class="fa fa-search"></i>
                </button>
            </div> -->
            <div class="search-container">
                <input tabindex="1" type="text" placeholder="{{'Patient ID' | customPatientLabel}}" (keydown.space)="$event.preventDefault()"
                    [(ngModel)]="patientInformationObject.patientInfo.externalId" (paste)="removeAllSpace()" placeholder="Search" [disabled]="!isEditable('patientId')" />
            </div>
        </div>
        <div *ngIf="hasField('firstName', 'edit', 'create')" style="margin-bottom: 8px;" class="col-md-3">
            <p>First Name<span style="color: red;" *ngIf="isRequired('firstName')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="First Name"
                [(ngModel)]="patientInformationObject.patientInfo.firstName" [disabled]="!isEditable('firstName')"
                 />
        </div>
        <div *ngIf="hasField('middleName', 'edit', 'create')" style="margin-bottom: 8px;" class="col-md-3">
            <p>Middle Name<span style="color: red;" *ngIf="isRequired('middleName')">*</span></p>
            <input tabindex="2" class="input-wrapper" type="text" class="input" placeholder="Middle Name"
                [(ngModel)]="patientInformationObject.patientInfo.middleName" [disabled]="!isEditable('middleName')"
                 />
        </div>
        <div *ngIf="hasField('lastName', 'edit', 'create')" style="margin-bottom: 8px;" class="col-md-3">
            <p>Last Name<span style="color: red;" *ngIf="isRequired('lastName')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="Last Name"
                  [(ngModel)]="patientInformationObject.patientInfo.lastName" [disabled]="!isEditable('lastName')"
                 />
        </div>
        <div *ngIf="hasField('gender', 'edit', 'create')" style="margin-bottom: 8px;" class="col-md-3 gender">
            <p>Gender<span style="color: red;" *ngIf="isRequired('gender')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.gender !== '' &&
                    patientInformationObject.patientInfo.gender != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.gender
                " [disabled]="!isEditable('gender')">
                <ng-option *ngFor="let obj of genderArr" [value]="obj.value">
                    {{ obj.label }}
                </ng-option>
            </ng-select>
        </div>
        <div *ngIf="hasField('dateOfBirth', 'edit', 'create')" style="margin-bottom: 8px;" class="col-md-3">
            <p>Date of Birth<span style="color: red;" *ngIf="isRequired('dateOfBirth')">*</span></p>
            <div class="form-group year" style="margin-bottom: 5px">
                <div class="input-group col-xs-12" style="display: flex; width: 100%">
                    <mat-form-field appearance="fill">
                        <input type="text" class="autocomplete-input" placeholder="Month" matInput
                            [matAutocomplete]="month" style="
                                caret-color: transparent;
                                border: none;
                                height: unset;
                            " [(ngModel)]="dateOfBirthObject.dobMonth" onkeydown="return false;"
                            (ngModelChange)="dateOfBirthObject.dobDay = null" [disabled]="!isEditable('dateOfBirth')" />
                        <i class="fa fa-caret-down align-arrow-right"></i>
                        <mat-autocomplete #month="matAutocomplete" class="min-width-unset"
                            [displayWith]="monthName.bind(this)">
                            <mat-option *ngFor="let item of months" [value]="item.id" style="font-size: 13px"
                                (click)="setDays()">
                                {{ item.displayName }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <input type="text" placeholder="Day" matInput [matAutocomplete]="day" style="
                                caret-color: transparent;
                                border: none;
                                height: unset;
                            " [(ngModel)]="dateOfBirthObject.dobDay" onkeydown="return false;" [disabled]="!isEditable('dateOfBirth')" />
                        <i class="fa fa-caret-down align-arrow-right"></i>
                        <mat-autocomplete #day="matAutocomplete" class="min-width-unset">
                            <mat-option *ngFor="let day of days" [value]="day" style="font-size: 13px">
                                {{ day }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <input style="width: 30%; font-size: 13px" id="year" type="text" tabindex="1" maxlength="4"
                        class="form-control virtual-care text-center" placeholder="Year"
                        [(ngModel)]="dateOfBirthObject.dobYear" (ngModelChange)="onDobYearChange($event)" (keypress)="checkNumber($event)" [disabled]="!isEditable('dateOfBirth')" />
                </div>
            </div>
        </div>
        <div *ngIf="hasField('cellPhone', 'edit', 'create')"  style="margin-bottom: 8px;" class="col-md-3">
            <p>Cell Phone <span style="color: red;" *ngIf="isRequired('cellPhone')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="Cell Phone"
                (keyup)="formatNumber()" (paste)="onPaste($event)" (keypress)="checkNumber($event)"
                [(ngModel)]="patientInformationObject.patientInfo.cellPhone" maxlength="15" [disabled]="!isEditable('cellPhone')" />
        </div>
        <div *ngIf="hasField('homePhone', 'edit')" style="margin-bottom: 8px;" class="col-md-3">
            <p>Home Phone <span style="color: red;" *ngIf="isRequired('homePhone')">*</span></p>
            <input tabindex="1" type="text" class="input" placeholder="Home Phone"
                (keyup)="formatNumber()" (paste)="onPaste($event)" (keypress)="checkNumber($event)"
                [(ngModel)]="patientInformationObject.patientInfo.homePhone" maxlength="15" [disabled]="!isEditable('homePhone')" />
        </div>
        <div *ngIf="hasField('email', 'edit')" style="margin-bottom: 8px;" class="col-md-3">
            <p>Email Address <span style="color: red;" *ngIf="isRequired('email')">*</span></p>
            <input tabindex="1"  type="text" class="input" placeholder="Email" [(ngModel)]="
                    patientInformationObject.patientInfo.email
                " disallowSpaces [disabled]="!isEditable('email')" />
        </div>
        <div class="col-md-3" style="margin-bottom: 8px;" *ngIf="hasField('address', 'edit')">
                <p>Street <span style="color: red;" *ngIf="isRequired('address')">*</span></p>
                <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="Street" [(ngModel)]="
                        patientInformationObject.patientInfo.address.addressLine1
                    " [disabled]="!isEditable('address')" />
        </div>
        <div class="col-md-3" style="margin-bottom: 8px;" *ngIf="hasField('address', 'edit')">
            <p>City <span style="color: red;" *ngIf="isRequired('address')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="City"
                [(ngModel)]="patientInformationObject.patientInfo.address.city" maxlength="15" [disabled]="!isEditable('address')" />
        </div>
        <div class="col-md-3" style="margin-bottom: 8px;" *ngIf="hasField('address', 'edit')">
            <p>State <span style="color: red;" *ngIf="isRequired('address')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.address
                        .stateOrProvinceCode !== '' &&
                    patientInformationObject.patientInfo.address
                        .stateOrProvinceCode != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.address
                        .stateOrProvinceCode
                " [disabled]="!isEditable('address')">
                <ng-option *ngFor="let state of data.stateList" [value]="state.value">
                    {{ state.valueShortDescription }}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-md-3" style="margin-bottom: 8px;" *ngIf="hasField('address', 'edit')">
            <p>ZIP <span style="color: red;" *ngIf="isRequired('address')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="ZIP" [(ngModel)]="
                    patientInformationObject.patientInfo.address.postalCode"
                    (keypress)="keyPressAlphaNumeric($event,  'number')"
                    (paste)="onPaste($event, 'number')"
                maxlength="9" [disabled]="!isEditable('address')" />
        </div>
        <div *ngIf="hasField('healthPlan', 'edit')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Health Plan <span style="color: red;" *ngIf="isRequired('healthPlan')">*</span></p>
            <!-- <input tabindex="1"  type="text" class="input" placeholder="Health Plan" [(ngModel)]="
                    patientInformationObject.patientInfo.healthPlan
                " disallowSpaces /> -->
             <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.healthPlan !== '' &&
                    patientInformationObject.patientInfo.healthPlan != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.healthPlan
                " [disabled]="!isEditable('healthPlan')">
                <ng-option *ngFor="let obj of healthPlanArray" [value]="obj">
                    {{ obj }}
                </ng-option>
            </ng-select>
        </div>
        <!-- <div *ngIf="hasField('memberId')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Member ID <span *ngIf="isRequired('memberId')">*</span></p>
            <input tabindex="1" class="input-wrapper" type="text" class="input" placeholder="Member ID" [(ngModel)]="
                    patientInformationObject.patientInfo.memberId
                " disallowSpaces />
        </div> -->
        <div *ngIf="hasField('preferredLanguage', 'edit')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Preferred Language <span  style="color: red;" *ngIf="isRequired('preferredLanguage')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.language !== '' &&
                    patientInformationObject.patientInfo.language != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.language
                " [disabled]="!isEditable('preferredLanguage')">
                <ng-option *ngFor="let obj of languageArray" [value]="obj">
                    {{ obj }}
                </ng-option>
            </ng-select>
        </div>
        <div *ngIf="!data.editPatient && hasField('timezone', 'edit')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Time Zone <span style="color: red;" *ngIf="isRequired('timezone')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.address
                        .timezone !== '' &&
                    patientInformationObject.patientInfo.address
                        .timezone != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.address
                        .timezone
                " [disabled]="!isEditable('timezone')">
                <ng-option *ngFor="let state of addressTimezone" [value]="state.value">
                    {{ state.valueShortDescription }}
                </ng-option>
            </ng-select>
        </div>
        <div *ngIf="hasField('leadSource', 'edit')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Lead Source <span style="color: red;" *ngIf="isRequired('leadSource')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.leadSource !== '' &&
                    patientInformationObject.patientInfo.leadSource != null
                "
                name="leadSource"
                [(ngModel)]="
                    patientInformationObject.patientInfo.leadSource
                " [disabled]="!isEditable('leadSource')">
                <ng-option *ngFor="let obj of leadSourceArray" [value]="obj">
                    {{ obj }}
                </ng-option>
            </ng-select>
        </div>
        <div *ngIf="hasField('callSource', 'edit')" class="col-md-3" style="margin-bottom: 8px; ">
            <p>Call Source <span style="color: red;" *ngIf="isRequired('callSource')">*</span></p>
            <ng-select [appendTo]="'body'" [clearable]="
                    patientInformationObject.patientInfo.callSource !== '' &&
                    patientInformationObject.patientInfo.callSource != null
                " [(ngModel)]="
                    patientInformationObject.patientInfo.callSource
                " [disabled]="!isEditable('callSource')">
                <ng-option *ngFor="let obj of callSourceArray" [value]="obj">
                    {{ obj }}
                </ng-option>
            </ng-select>
        </div>

        <ng-container *ngIf="!data.editPatient && getDynamicPatientCreationFields().length">
            <div *ngFor="let field of getDynamicPatientCreationFields()" class="col-md-3" style="margin-bottom: 8px;" [hidden]="isStandardPatientField(field)">
                <p>{{ getFieldDisplayName(field) }} <span style="color: red;" *ngIf="isRequired(getFieldBindingKey(field))">*</span></p>

                <ng-select *ngIf="field?.type === 'DROPDOWN' || (field?.type && field.type.toString().toUpperCase().includes('DROPDOWN'))"
                    [appendTo]="'body'"
                    [clearable]="true"
                    [ngModel]="getFieldValue(field)"
                    (ngModelChange)="setFieldValue(field, $event)"
                    [disabled]="!isEditable(getFieldBindingKey(field))">
                    <ng-option *ngFor="let option of getFieldOptions(field)" [value]="option">
                        {{ option }}
                    </ng-option>
                </ng-select>

                <input *ngIf="field?.type === 'NUMERIC' || (!field?.type && !field?.options) || (!(field?.type && field.type.toString().toUpperCase().includes('DROPDOWN')) && !(field?.type && field.type.toString().toUpperCase().includes('BOOLEAN')) && !(field?.type && field.type.toString().toUpperCase().includes('PHONE')) && !(field?.type && field.type.toString().toUpperCase().includes('EMAIL')) )"
                    type="text"
                    class="input"
                    [ngModel]="getFieldValue(field)"
                    (ngModelChange)="setFieldValue(field, $event)"
                    [disabled]="!isEditable(getFieldBindingKey(field))"
                    [placeholder]="getFieldDisplayName(field)" />

                <input *ngIf="field?.type && field.type.toString().toUpperCase().includes('PHONE')"
                    type="text"
                    class="input"
                    (keyup)="formatNumber()"
                    (paste)="onPaste($event)"
                    (keypress)="checkNumber($event)"
                    [ngModel]="getFieldValue(field)"
                    (ngModelChange)="setFieldValue(field, $event)"
                    [disabled]="!isEditable(getFieldBindingKey(field))"
                    [placeholder]="getFieldDisplayName(field)" />

                <input *ngIf="field?.type && field.type.toString().toUpperCase().includes('EMAIL')"
                    type="email"
                    class="input"
                    [ngModel]="getFieldValue(field)"
                    (ngModelChange)="setFieldValue(field, $event)"
                    [disabled]="!isEditable(getFieldBindingKey(field))"
                    [placeholder]="getFieldDisplayName(field)" />

                <input *ngIf="field?.type && field.type.toString().toUpperCase().includes('BOOLEAN')"
                    type="checkbox"
                    [ngModel]="getFieldValue(field)"
                    (ngModelChange)="setFieldValue(field, $event)"
                    [disabled]="!isEditable(getFieldBindingKey(field))" />
            </div>
        </ng-container>

        <div *ngIf="data.editPatient && data.patientAdditionalFields?.isAdditionalFieldsEnabled" style="border-bottom: 2px dotted rgb(193, 193, 193);width: 100%;padding: 10px 16px;margin-bottom: 16px;">
            Additional Fields
        </div>
        <div [hidden]="!(data.patientAdditionalFields?.isAdditionalFieldsEnabled && (col.dataProperty !== 'leadStatus' && col.dataProperty !== 'statusDetail' && col.dataProperty !== 'appAccess'))"  *ngFor="let col of groupedAdditionalFields" class="col-md-3" style="margin-bottom: 8px; ">
            <p *ngIf="col.type !== 'BOOLEAN'">
            {{ col.columnName }}<span *ngIf="isFieldRequired(col) && isAdditionalFieldEditable(col)" style="color:red">*</span>
            </p>
            <span >
                <ng-select *ngIf="col.type === 'DROPDOWN'"
                        name="{{col.columnValue}}"
                        [appendTo]="'body'"
                        [clearable]="(formData[col.dataProperty] == '' || formData[col.dataProperty] == null) ? false : true"
                        [placeholder]="'Select ' + col.columnName"
                        [(ngModel)]="formData[col.dataProperty]"
                        [required]="col.isRequired && isAdditionalFieldEditable(col)"
                        [disabled]="!isAdditionalFieldEditable(col)">
                <ng-option *ngFor="let option of getDropDownList(col.dataProperty)" [value]="option">{{ option }}</ng-option>
                </ng-select>
                <input *ngIf="col.type === 'NUMERIC'"
                    type="number"
                    class="input-wrapper"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [disabled]="!isAdditionalFieldEditable(col)"
                    [placeholder]="'Enter ' + col.columnName" />
                <input *ngIf="col.type === 'NUMERIC(PHONE)'"
                    type="text"
                    maxlength="15"
                    (keyup)="formatNumber()"
                    (paste)="onPaste($event)"
                    (keypress)="checkNumber($event)"
                    [class.field-disabled]="isPatientUsernameField(col) && !isPatientUsernameValidTenDigitNumber(col)"
                    class="input-wrapper"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [disabled]="!isPatientUsernameValidTenDigitNumber(col) && !isAdditionalFieldEditable(col)"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [placeholder]="'Enter ' + col.columnName" />
                <input *ngIf="col.type === 'ALPHA'"
                    type="text"
                    class="input-wrapper"
                    (keypress)="keyPressAlphaNumeric($event,  'alpha')"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [disabled]="!isAdditionalFieldEditable(col)"
                    [placeholder]="'Enter ' + col.columnName" />

                <input *ngIf="col.type === 'ALPHANUMERIC(EMAIL)'"
                    type="text"
                    class="input-wrapper"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [disabled]="!isAdditionalFieldEditable(col)"
                    [placeholder]="'Enter ' + col.columnName" />

                <input *ngIf="col.type === 'ALPHANUMERIC'"
                    type="text"
                    class="input-wrapper"
                    (keypress)="keyPressAlphaNumeric($event, 'alphanumeric')"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [disabled]="!isAdditionalFieldEditable(col)"
                    [placeholder]="'Enter ' + col.columnName" />

            <label for="{{col.columnValue}}" *ngIf="col.type == 'BOOLEAN'">
                {{ col.columnName }}<span *ngIf="isFieldRequired(col) && isAdditionalFieldEditable(col)" style="color:red">*</span>
            </label>
                <input *ngIf="col.type === 'BOOLEAN'"
                    id="{{col.columnValue}}"
                    type="checkbox"
                    [checked]="formData[col.dataProperty] == 1 || formData[col.dataProperty] == true"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired && isAdditionalFieldEditable(col)"
                    [disabled]="!isAdditionalFieldEditable(col)"
                    />
            </span>
            <!-- for statusdetails and leadstatus will be not shown -->
            <!-- <span *ngIf="col.dataProperty === 'leadStatus' || col.dataProperty === 'statusDetail'">
                <input 
                    disabled="true"
                    type="text"
                    class="input-wrapper"
                    (keypress)="keyPressAlphaNumeric($event,  'alpha')"
                    name="{{col.columnValue}}"
                    [(ngModel)]="formData[col.dataProperty]"
                    [required]="col.isRequired"
                    [placeholder]="'Enter ' + col.columnName" />
            </span> -->
        </div>
    </div>
 </div>
<div *ngIf="!data.editPatient" style="padding: 0px 30px">
    <div class="modal-footer" style="
            padding: 15px 0px;
            display: block;
            border-top: 1px dashed #d9d9d6;
        ">
        <div class="row" style="padding: 10px; padding-right: 0px; margin-right: 0px">
            <div class="col-md-12" style="display: flex; justify-content: end; padding-right: 0px">
                <button *ngIf="showBackToSearchBtn" style="
                        padding: 6px 30px;
                        margin-right: 10px;
                        border: 1px solid #dedede;
                        font-size: inherit;
                    " class="btn btn-default" (click)="backToSearch()">
                    Back to Search
                </button>
                <button [disabled]="loader" style="
                        padding: 10px 25px;
                        border: none;
                        background: #1fbd75;
                        color: white;
                    " (click)="createPatientInformation()">
                    Save {{'Patient' | customPatientLabel}}
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="data.editPatient" style="padding: 0px 30px">
    <div class="modal-footer" style="
            padding: 15px 0px;
            display: block;
            border-top: 1px dashed #d9d9d6;
        ">
        <div class="row" style="padding: 10px; padding-right: 0px; margin-right: 0px">
            <div class="col-md-12" style="display: flex; justify-content: end; padding-right: 0px">
                <button style="
                        padding: 6px 30px;
                        margin-right: 10px;
                        border: 1px solid #dedede;
                        font-size: inherit;
                    " class="btn btn-default" (click)="backToSearch()">
                    Cancel
                </button>
                <button class="btn-save-update" (click)="updatePatientDetails()"
                    [disabled]="loader || !isFormChanged"
                    >
                    <div *ngIf="loader" style="margin: -5px">
                        <span class="submit-loader"></span> Loading...
                    </div>
                    <span *ngIf="!loader">Update</span>
                </button>
            </div>
        </div>
    </div>
</div>
